import { rei } from "@/services/api"
import axios from 'axios'

class CertidoesCRCService {
  
  static obterPedidosPendentes () {
    return rei.post(`certidoes-crc/obter-pedidos-pendentes-crc`)
  }

  static obterTodosPedidos (modulo) {
    return rei.post(`certidoes-crc/obter-pedidos-salvos`, { modulo })
  }

  static obterRegistrosPelaMatricula (matricula, numero_do_pedido_crc) {
    return rei.post(`certidoes-crc/obter-registros-matricula`, { matricula, numero_do_pedido_crc })
  }
  
  static enviarPedido (assinatura, pedido, emolumentos, osSelected) {
    return rei.post(`certidoes-crc/enviar-pedido`, {assinatura , pedido, emolumentos, osSelected})
  }

  static obterPedidoById (numero) {
    return rei.post(`certidoes-crc/obter-pedido-by-id`, { numero })
  }

  static rejeicaoDoPedido (pedido) {
    return rei.post(`certidoes-crc/rejeitar-pedido`, pedido)
  }

  static obterPedidosCumpridos ( payload ) {
    return rei.post(`certidoes-crc/obter-pedidos-cumpridos`, payload)
  }

  // static cumprirPedidosPendentes (certidoes) {
  //   return rei.post('certidao/cumprir-pedidos-pendentes-crc', certidoes).then(res => res.data)
  // }
}

export default CertidoesCRCService